module Tapas.Bindings {
    export interface ILoadMoreItemsArgs {
        currentPage: number;
        totalPages: number;
        layoutTemplate: string;
        text: string;
    }
    export class LoadMoreItems {
        public init(element: any, valueAccessor: () => ILoadMoreItemsArgs, allBindingsAccessor?: KnockoutAllBindingsAccessor, viewModel?: any, bindingContext?: KnockoutBindingContext) {
            if (!bindingContext)
                return;

            var load = bindingContext.$root.load();
            var currentPage = valueAccessor().currentPage;
            var totalPages = valueAccessor().totalPages;
            var layoutTemplate = valueAccessor().layoutTemplate;
            
            var http = new Ftw.Data();
            var currentlyLoading = false;

            $(document).scroll(() => {
                if (totalPages > currentPage) {

                    var nextPage = currentPage + 1;
                    var loadElement = $(element).offset().top;
                    var y = $(document).scrollTop() + $(window).height();
                    if (y >= loadElement && currentlyLoading == false) {
                        currentlyLoading = true;
                        load.active(true);
                        load.text(valueAccessor().text);

                        var data = {
                            LayoutTemplate: layoutTemplate,
                            page: nextPage,
                            ajaxTapas: true
                        };                       

                        http.get(window.location.pathname, data)
                            .then((data) => {

                                var itemData = $(data).children().html();
                                $(element).before(itemData);
                                var childBindingContext = bindingContext.createChildContext(viewModel);
                                currentPage++;

                                ko.applyBindingsToDescendants(childBindingContext, document.getElementById(nextPage.toString()));
                            })
                            .finally(() => {
                                load.active(false);
                                load.text("");
                                currentlyLoading = false;
                            });
                    }
                }
            });

            $(window).unload(function () {
                load.active(false);
            });
        }
    }
    ko.bindingHandlers['loadMoreItems'] = new LoadMoreItems();
} 


